<template>
	<div class="wrapper">
		<div>
			<div class="zz_jianshu_forum">
				<div class="zz_jianshu_forumbanner">
					<img src="../../../assets/zz_jianshu_ficon.png" alt="">
					<span>
						今日：{{object.today}}
						&nbsp;
						昨日：{{object.yesterday}}
						&nbsp;
						帖子：{{object.sum}}
						&nbsp;
						会员数：{{object.usernum}}
<!-- 						&nbsp;
						新会员：<span>赵晓卿</span> -->
					</span>
				</div>
			</div>
			
			<div class="zz_jianshu_forum_list">
					<div class="lis" v-for="(item,i) in list" :key="i" @click="forumdisplay(item)">
						<div class="zz_ztbg">
							<div style="position: relative;">
								<div class="zhanzhuai-block-icon">
									<img src="../../../assets/forum.gif" alt="">
								</div>
								<div class="zhanzhuai-block-content">
									<p class="zhanzhuai-block-name">
										{{item.title}}
									</p>
									<p class="zhanzhuai-block-description">
										{{item.intor?item.intor:'呜呜...暂无专题描述'}}
										
									</p>
								</div>
								<div class="zhanzhuai-block-ingress">进入专题</div>
								<div class="zhanzhuai-block-count">
									<span>
										今日 {{item.todayNum}} 篇
										<em style="margin: 0 5px;">·</em>
										帖子 {{item.sum}} 篇
									</span>
								</div>
							</div>
						</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import { zhuanti_list,zhuanti_data } from "@/api/boke"
	export default{
		data(){
			return{
				list:[],
				loading:false,
				object:{
					today:0,
					yesterday:0,
					sum:0,
					usernum:0
				},
			}
		},
		mounted(){
			this.zhuanti_list();
		},
		methods:{
			async zhuanti_list(){
				this.loading = true
				await zhuanti_list({}).then(res=>{
					this.loading = false
					console.log("专题列表",res.data);
					this.list = res.data
				}).catch(()=>{
					this.loading = false
				})
				await zhuanti_data({}).then(res=>{
					this.object = res.data
				}).catch(()=>{
					
				})
			},
			forumdisplay(item){
				this.$router.push({
					path:"/forumdisplay",
					query:{
						zhuantiid:item.id,
						title:item.title
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.zhanzhuai-block-ingress{
		    display: inline-block;
		    width: 70px;
		    height: 30px;
		    line-height: 30px;
		    padding: 0 10px;
		    font-size: 14px;
		    color: #72D072;
		    border-radius: 20px;
		    border: 1px solid #72D072;
			transition: all .3s ease;
			cursor: pointer;
			span{
				font-size: 13px;
				    color: #888;
				    overflow: hidden;
				    text-overflow: ellipsis;
				    white-space: nowrap;
			}
	}
	.zhanzhuai-block-ingress:hover{
		background: #72D072;
		color: #fff;
	}
	.zhanzhuai-block-count{
		margin-top: 20px;
		    padding-top: 20px;
		    border-top: 1px solid #f0f0f0;
		span{
			font-size: 13px;
			    color: #888;
			    overflow: hidden;
			    text-overflow: ellipsis;
			    white-space: nowrap;
			}
	}
	.zz_jianshu_forum_list{
		width: 1220px;
		margin: 0 -20px 20px 0;
		.zhanzhuai-block-name{
			margin-bottom: 10px;
			font-size: 21px;
			    font-weight: 700;
			    overflow: hidden;
			    text-overflow: ellipsis;
			    white-space: nowrap;
				color: #333;
				cursor: pointer;
		}
		.zhanzhuai-block-description{
			height: 25px;
			    line-height: 25px;
			    margin-bottom: 19px;
			    font-size: 14px;
			    color: #7b7b7b;
			    text-overflow: ellipsis;
			    white-space: nowrap;
			    overflow: hidden;
		}
		.zhanzhuai-block-name:hover{
			color: #FFA07A;
		}
		.zhanzhuai-block-icon{
			width: 82px;
			    height: 82px;
			    margin: 9px auto 12px;
			    text-align: center;
			img{
				width: 80px;
				    height: 80px;
				    background: #f5f6f7;
				    border: 1px solid #ddd;
				    border-radius: 50%;
			}
		}
		.lis{
			position: relative;
			float: left;
			height: 231px;
			width: 245px;
			margin: 70px 20px 0 0;
			padding: 20px;
			background: #fff;
			border-radius: 4px;
			border: 0;
			transition: all .6s ease;
			text-align: center;
			.zz_ztbg{
				position: absolute;
				top: -45px;
				left: 50%;
				width: 200px;
				height: 62px;
				margin-left: -102px;
				background: url('../../../assets/zz_ztbg.png') no-repeat center 0;
			}
		}
	}
	.zz_jianshu_forum{
		width: 100%;
		height: 128px;
		.zz_jianshu_forumbanner{
			position: relative;
			height: 100%;
			line-height: 128px;
			overflow: hidden;
			span{
				position: relative;
				    float: right;
				    margin-right: 25px;
				    font-size: 15px;
				    color: #fff;
				span{
					color: #c7254e;
					cursor: pointer;
				}
			}
			img{
				position: absolute;
				top: 0;
				left: 0;
				width: 1200px;
				min-height: 100px;
				background-color: hsla(0,0%,71%,.2);
				border-radius: 4px;
				overflow: hidden;
			}
		}
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/luntan/index.vue